export interface SalesOrderLineCommissionDetails {
  id: string;
  salesOrderHeaderId: string;
  salesOrderAndLineNo: string;
  customerKey: string;
  customerName: string;
  sequence: number;
  productId: string;
  productKey: string;
  productDescription: string;
  currencySymbol: string;
  currencyDescriptionOverride: string;
  unitOfMeasureDescription: string;
  customerLineRef: string;
  quantity: number;
  price: number;
  deliveryDate: Date;
  customerClientRef1: string;
  customerClientRef2: string;
  customerClientRef3: string;
  commission: number;
}
